var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"xl":"6","lg":"8","md":"12","sm":"12"}},[_c('ExportAbutment',{staticClass:"mt-1",on:{"exported":_vm.onExport,"cancelled":function($event){return _vm.$emit('cancelled')}}})],1),_c('v-col',{staticClass:"pa-0",attrs:{"xl":"6","lg":"4","md":"12","sm":"12"}},[_c('v-card',{class:{
        'rounded-20': true,
        'mt-4': true,
        'ml-4': _vm.$vuetify.breakpoint.lgAndUp
      },attrs:{"flat":""}},[_c('v-card-text',[_c('ExistingExports',{model:{value:(_vm.newExportUid),callback:function ($$v) {_vm.newExportUid=$$v},expression:"newExportUid"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }